import styled from 'styled-components';

import { spacing } from '_utils/props';
import { mq, svg, text_s, text_xs, heading_s, heading_xs } from '_utils/styles/';

export const ListWrapper = styled.div`
  width: 100%;
  border-radius: ${({ theme }) => theme.card.borderRadius}px;
  border: 1px solid ${({ theme }) => theme.colors.downloads.border};
`;

export const DownloadWrapper = styled.div`
  display: flex;
  ${({ theme }) => spacing({ theme, $p: 3 })};
  flex-direction: column;

  ${mq('sm')} {
    flex-direction: row;
    align-items: flex-start;
  }

  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.downloads.border};
  }
`;

export const IconWrapper = styled.div<{ $variation?: string }>`
  ${({ $variation = 'false' }) => ($variation == 'true' ? svg(13, 16) : svg(22, 27))}
  width: ${({ $variation = 'false' }) => ($variation == 'true' ? 13 : 22)}px;
  flex-shrink: 0;

  ${({ $variation }) => {
    if ($variation == 'true') {
      return `
        top: 2px;
      `;
    }

    return `
      ${mq.lessThan('sm')} {
        margin-bottom: 18px;
      }
    `;
  }}
`;

export const TextWrapper = styled.div<{ $variation?: string }>`
  flex-grow: 1;

  ${({ $variation = 'false', theme }) => {
    if ($variation == 'true') {
      return spacing({ theme, $ml: 2 });
    }

    return `
      margin: 0;

      ${mq('sm')} {
        ${spacing({ theme, $ml: 2 })};
      }
    `;
  }}
  @media print {
    page-break-inside: avoid;
  }
`;

export const DownloadIconWrapper = styled.span`
  ${svg(16, 18)}
  width: 16px;
  margin-left: 12px;
  display: flex;

  path {
    fill: ${({ theme }) => theme.colors.element.tertiary};
  }
`;

export const DownloadTitle = styled.span`
  display: block;
  margin: 0;
  ${heading_s}
  color: ${({ theme }) => theme.colors.link.secondary.color};
  transition: color 0.2s linear;
`;

export const DownloadAttributes = styled.span`
  display: block;
  ${text_xs};
  margin: 0;
  ${({ theme }) => spacing({ theme, $mt: 1 })};
  color: ${({ theme }) => theme.colors.element.quaternary};
`;

export const DownloadDescription = styled.p`
  ${text_s}
  margin: 0;
  ${({ theme }) => spacing({ theme, $mt: 1 })};
  color: ${({ theme }) => theme.colors.element.quaternary};
`;

export const DownloadLink = styled.a`
  flex: 1 0 auto;
  display: flex;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.element.primary};

  &:hover,
  &:active {
    color: ${({ theme }) => theme.colors.link.secondary.colorHover};
  }

  &:visited {
    color: ${({ theme }) => theme.colors.link.secondary.colorVisited};
  }
`;

export const VariationWrapper = styled(ListWrapper)`
  ${({ theme }) => spacing({ theme, $p: 2, $mt: 3 })};
`;

export const VariationDownloadWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  & + & {
    ${({ theme }) => spacing({ theme, $mt: 2 })};
  }

  ${DownloadTitle} {
    ${heading_xs}
    font-weight: normal;
    text-decoration: underline;
  }
`;

export const EditorDiv = styled.div``;
